export default __webpack_public_path__ + "static/media/first-left-img@1x.aab335ad.webp";